import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { DemoCatalog } from '../components/dashboard/DemoCatalogSection';
import { workbenchHrefForDemo } from '../components/dashboard/demoCatalog';
import { DashboardIcon } from '../components/dashboard/DashboardIcon';

export const DemoLibrary: React.FC<{ guest?: boolean }> = ({ guest = false }) => {
    const navigate = useNavigate();

    return (
        <div className="p-6 space-y-6" data-testid={guest ? 'guest-demo-library' : 'demo-library'}>
            <div className="mb-2">
                <div className="flex items-center gap-2.5 mb-1">
                    <DashboardIcon variant="tile" tone="tutorials" icon={GraduationCap} />
                    <h1 className="text-2xl font-bold tracking-tight">Demo library</h1>
                </div>
                <p className="text-muted-foreground text-sm max-w-2xl pl-[2.625rem]">
                    {guest
                        ? 'Training graphs on Mock/Cached data — not live cases. Sign in for Live chain tools and case save.'
                        : 'Training graphs and a canvas legend — not live cases. Open a scenario to load it on the Workbench.'}
                </p>
            </div>
            <DemoCatalog
                onScenarioClick={(scenario) => {
                    navigate(workbenchHrefForDemo(scenario, { guest }));
                }}
            />
        </div>
    );
};
